module.exports = __webpack_public_path__ + "img/banner3_2_en.255e5b58.png";